import { ClientInfo } from "./FormsClientInfo";

export function fixClientInfo(clientInfo: ClientInfo): ClientInfo {
    let result = clientInfo;
    const birthDate = clientInfo.CurrentAccount?.Chief?.BirthDate;
    if (birthDate != undefined && birthDate !== "") {
        const normalizedDate = normalizeDate(birthDate);
        if (normalizedDate !== birthDate) {
            result = {
                ...result,
                CurrentAccount: {
                    ...result.CurrentAccount,
                    Chief: {
                        ...result.CurrentAccount?.Chief,
                        BirthDate: normalizedDate,
                    },
                },
            };
        }
    }
    return result;
}

function normalizeDate(inputDateString: string): string | undefined {
    const resultDate = new Date(inputDateString);
    if (isNaN(resultDate.getTime())) {
        return undefined;
    }
    return resultDate.toISOString();
}
